import { pulseTypes } from 'redux/pulse';
import merge from 'lodash/merge';

const pulseSurveySchedulesReducer = (state = {}, { type, payload }) => {
  switch (type) {
    case pulseTypes.deletePulseSurveyScheduleSuccess:
      return merge({}, state, { [payload.request.pulseSurveyScheduleId]: null });
    case pulseTypes.updatePulseSurveyScheduleSuccess:
      return merge({}, state, {
        [payload.request.pulseSurveyScheduleId]: {
          ...state[payload.request.pulseSurveyScheduleId],
          ...payload.entities.pulseSurveySchedules[payload.request.pulseSurveyScheduleId],
        },
      });
    default:
      return state;
  }
};

export default pulseSurveySchedulesReducer;
